import React from 'react';
import { ActiveMissionsList, AvailableMissionsList } from '../../FlowchartView/components/FlowchartHUD/MissionsList';

export function NeuralMissionHud({
  activeTasks,
  blockedTasks,
  waitingTasks = [],
  availableTasks,
  localActiveCollapsed,
  localAvailableCollapsed,
  onToggleActive,
  onToggleAvailable,
  onGoToTask,
  selectedMissionId,
}) {
  return (
    <div className="neural-view__mission-hud">
      {(activeTasks.length > 0 || blockedTasks.length > 0) && (
        <div className="flowchart-hud__top-left">
          <div className="flowchart-hud__glass-card flowchart-hud__glass-card--missions flowchart-hud__glass-card--active">
            <ActiveMissionsList
              tasks={activeTasks}
              blockedTasks={blockedTasks}
              isCollapsed={localActiveCollapsed}
              onToggle={onToggleActive}
              onGoToTask={onGoToTask}
              hoveredMissionId={selectedMissionId}
              isMultiCampaignMode={false}
            />
          </div>
        </div>
      )}
      <div className="flowchart-hud__quest-log">
        <div className="flowchart-hud__glass-card flowchart-hud__glass-card--missions flowchart-hud__glass-card--available">
          <AvailableMissionsList
            tasks={availableTasks}
            waitingTasks={waitingTasks}
            activeTasks={activeTasks}
            isCollapsed={localAvailableCollapsed}
            onToggle={onToggleAvailable}
            onGoToTask={onGoToTask}
            hoveredMissionId={selectedMissionId}
            isMultiCampaignMode={false}
          />
        </div>
      </div>
    </div>
  );
}
